const svgXIcon =
	'<svg width="14px" height="14px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fbfbfb" stroke-width="1"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z" fill="#fbfbfb"></path> </g></svg>'
const svgCheckIcon =
	'<svg width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#fbfbfb" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>'

const checkIcon = {
	svg: svgCheckIcon,
	alignment: 'center',
	margin: [0, 4, 0, 1],
	fillColor: '#e94e24',
}
const xIcon = {
	svg: svgXIcon,
	margin: [0, 6, 0, 4],
	alignment: 'center',
	fillColor: '#46244c',
}

function clone(obj) {
	return Object.assign({}, obj)
}

const headers = [
	{
		text: '# - Tese',
		style: 'tableHeader',
		verticalAlign: 'middle',
	},
]
const widths = ['50%']
const rows = []
const tableContent = []
const user = {
	name: '',
	email: '',
	avatar: '',
}

function clear() {
	clearHeader()
	clearRows()
}

function clearHeader() {
	headers.length = 0
	headers.push({
		text: '# - Tese',
		style: 'tableHeader',
		verticalAlign: 'middle',
	})

	widths.length = 0
	widths.push('50%')
}

function addHeader(title) {
	headers.push({
		text: title,
		style: 'tableHeaderCompany',
		verticalAlign: 'middle',
	})

	widths.push('*')
}

function clearRows() {
	rows.length = 0
}

// exemplo ['Nome da tese', true, false]
function addRow(row) {
	row = row.map((cell, index) => {
		if (index === 0) {
			return {
				text: cell,
				verticalAlign: 'middle',
			}
		} else return cell ? clone(checkIcon) : clone(xIcon)
	})

	rows.push(row)
}

function setUser(name, email) {
	user.name = name
	user.email = email
}

function download(filename = 'Quadro Comparativo - Locatelli') {
	tableContent.length = 0
	tableContent.push(headers)
	rows.forEach((row) => {
		tableContent.push(row)
	})

	window.pdfMake.createPdf(dd()).download(filename)
}

function dd() {
	return {
		info: {
			title: 'Quadro Comparativo - Locatelli',
			author: 'Locatelli Adogados',
		},
		pageMargins: [30, 160, 30, 40],
		pageSize: {
			width: 290 * 3.2,
			height: 375 * 3.2,
		},
		images: {
			logo: window.location.origin + '/logo-locatelli.jpeg',
		},
		background: [
			{
				columns: [
					{
						image: 'logo',
						height: 140,
						width: 330,
					},
					{
						svg: '<svg width="600" height="140"><rect width="600" height="140" style="fill:#003e51;" /></svg>',
					},
				],
			},
			{
				columns: [
					{
						svg: '<svg width="1800" height="3"><rect width="1800" height="3" style="fill:#e94e24;" /></svg>',
					},
				],
			},
		],
		header: [
			{
				columns: [
					{ text: '', width: 330 },
					{
						stack: [
							{
								text: 'Termômetro',
								fontSize: 32,
								bold: true,
								color: '#fff',
								margin: [15, 50, 0, 5],
							},
							{
								text: new Date().toLocaleDateString('pt', {
									year: 'numeric',
									month: '2-digit',
									day: 'numeric',
								}),
								fontSize: 12,
								bold: true,
								color: '#fff',
								margin: [15, 0, 0, 0],
							},
						],
					},
				],
			},
		],
		content: [
			{
				columns: [
					{
						text: user.name,
						width: 'auto',
						margin: [0, 0, 10, 0],
					},
					{ text: user.email, width: 'auto' },
					{ text: '', width: '*' },
					{
						text: [
							{
								text: 'Conheça nossas redes ',
								alignment: 'right',
							},
							{
								text: '  ',
								link: 'https://locatelliadv.com.br/',
								style: 'icon',
							},
							{
								text: '  ',
								link: 'https://www.linkedin.com/company/locatelli-advogados-tributario',
								style: 'icon',
							},
							{
								text: '  ',
								link: 'https://www.instagram.com/locatelli_advogados/',
								style: 'icon',
							},
							{
								text: ' ',
								link: 'https://www.youtube.com/channel/UCR8L1Fe85xS1snTE2BLUaiQ',
								style: 'icon',
							},
						],
					},
				],
				alignment: 'center',
				margin: [0, 0, 0, 20],
				fontSize: 15,
			},
			{
				text: 'Quadro Comparativo',
				fontSize: 20,
			},
			{
				style: 'tableExample',
				layout: 'lightHorizontalLines',
				table: {
					headerRows: 1,
					widths: widths,
					keepWithHeaderRows: 1,
					dontBreakRows: true,
					body: tableContent,
				},
			},
			{
				text: 'Aviso Legal',
				fontSize: 20,
				margin: [0, 20, 0, 5],
			},
			{
				text: 'As informações constantes neste relatório são apenas indicativas e originadas de bases públicas disponibilizadas pelo Judiciário. Não utilizamos a base completa de dados dos processos e das empresas.',
			},
		],
		styles: {
			tableExample: {
				margin: [0, 5, 0, 5],
			},
			tableHeader: {
				bold: true,
				fontSize: 13,
				color: 'black',
			},
			tableHeaderCompany: {
				bold: true,
				fontSize: 13,
				color: 'black',
				alignment: 'center',
			},
			icon: { font: 'icon', color: '#e94e24' },
		},
	}
}

export default {
	addRow,
	addHeader,
	clear,
	setUser,
	download,
}
